import { Link } from "react-router-dom";
import { Shield, Award, Heart, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import garrisonPhoto from "@/assets/garrison-huggins.webp";

const AboutOwnerSection = () => {
  return (
    <section className="section-padding bg-muted">
      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image Side */}
          <div className="relative animate-fade-in">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src={garrisonPhoto} 
                alt="Garrison Huggins - Owner of Stream Masters Power Washing" 
                width={600}
                height={750}
                loading="lazy"
                className="w-full aspect-[4/5] object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary/30 to-transparent pointer-events-none" />
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-6 -right-6 bg-primary text-primary-foreground p-6 rounded-2xl shadow-xl">
              <div className="text-center">
                <Shield className="w-10 h-10 mx-auto mb-2" />
                <p className="font-bold text-lg">Veteran Owned</p>
                <p className="text-sm opacity-90">& Operated</p>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="space-y-6 animate-fade-in">
            <div>
              <p className="text-primary font-semibold text-lg mb-2">MEET THE OWNER</p>
              <h2 className="text-3xl md:text-4xl font-bold font-heading text-secondary mb-4">
                GARRISON HUGGINS - <span className="text-primary">STREAM MASTERS</span>
              </h2>
            </div>

            <p className="text-lg text-muted-foreground leading-relaxed">
              I returned home from a deployment overseas and started a family. During this time, the world was 
              going through the COVID epidemic. As we all know, the U.S. economy was hit very hard, especially 
              in the housing industry. I knew just being a fireman wasn't going to suffice in building my family 
              a home. So, I hunkered down and specialized in the exterior cleaning industry. With my knowledge of 
              water pumping equipment and chemical background, I started Stream Masters Power Washing LLC. With 
              customer satisfaction being my primary focus, I quickly grew the company.
            </p>

            <p className="text-lg text-muted-foreground leading-relaxed">
              As a veteran-owned company, Stream Masters Power Washing takes pride in providing the best service 
              possible to our clients. As a family man, I understand the importance of making sure your home or 
              business is well taken care of. That's why I started this company - to build a better future for my 
              family by providing quality power washing services to the community. With 10 years of experience as 
              a firefighter, I've learned the importance of hard work, discipline, and attention to detail. These 
              values are the foundation of every project we undertake.
            </p>

            {/* Values Grid */}
            <div className="grid grid-cols-2 gap-4 py-4">
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 p-3 rounded-full"><Shield className="w-5 h-5 text-primary" /></div>
                <span className="font-semibold text-secondary">Veteran Values</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 p-3 rounded-full"><Award className="w-5 h-5 text-primary" /></div>
                <span className="font-semibold text-secondary">Firefighter Discipline</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 p-3 rounded-full"><Heart className="w-5 h-5 text-primary" /></div>
                <span className="font-semibold text-secondary">Family Owned</span>
              </div>
              <div className="flex items-center gap-3">
                <div className="bg-primary/10 p-3 rounded-full"><Users className="w-5 h-5 text-primary" /></div>
                <span className="font-semibold text-secondary">Community Focused</span>
              </div>
            </div>

            <div className="pt-4">
              <Link to="/about">
                <Button size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-bold">
                  Learn More About Us
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutOwnerSection;